import common from "../../common";
import GelButton from "./GelButton";

export default class GelMuteButton extends GelButton {
    constructor(states) {
        super(states);

        this._currentIconTexture = this.isEnabled() ? this._states.icon : this._states.iconAlt;
        this._currentIconOverTexture = this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
        this._currentIconDownTexture = this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

        this.setIconTexture((this._states.iconOver && !PIXI.utils.ismobilejs.any) ?
            this._currentIconOverTexture : this._currentIconTexture);
    }

    updateTextures() {
        this._currentIconTexture = this.isEnabled() ? this._states.icon : this._states.iconAlt;
        this._currentIconOverTexture = this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
        this._currentIconDownTexture = this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

        this.setIconTexture(this._states.iconOver && !PIXI.utils.ismobilejs.any ?
            this._currentIconOverTexture : this._currentIconTexture);
    }

    onMouseClick(event) {
        let settings = common.gmi.getAllSettings();

        console.warn("before -", "audio:", settings.audio, "muted:", settings.muted, "p3mute:", P3.audio.isMute);

        if (!!P3.audio)
        {
            common.gmi.setAudio(!settings.audio);

            settings = common.gmi.getAllSettings()
            P3.audio.mute(settings.muted);
        }

        console.warn("after -", "audio:", settings.audio, "muted:", settings.muted, "p3mute:", P3.audio.isMute);

        this.updateTextures();

        super.onMouseClick(event);
    }

    isEnabled() {
        return !!P3.audio && !P3.audio.isMute;
    }
}